module.exports = __webpack_public_path__ + "static/img/activity_sdy_08-3.e337c27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_08-3.jpg
// module id = /Qwe
// module chunks = 0